import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-quick-facts',
  templateUrl: './quick-facts.component.html',
  styleUrls: ['./quick-facts.component.scss']
})
export class QuickFactsComponent implements OnInit {
  quickFactData = {
    collegeProfile: '',
    yearEstablished: '',
    city : '',
    enrollment : '',
    schoolType: '',
    calendar : '',
    sixYearGraduationRate : '',
    tuition : '',
    averageAid : '',
    applicationDueDate : '',
    selectivity : '',
    religiousAffiliation : '',
    historicallyBlack : '',
    carnegie : '',
    degreeType : '',
    freshmanRetentionRate : '',
    phone : '',
    email: '',
    missionStatement : ''
  };
  constructor(private _commonService: CommonService) { }

  ngOnInit() {
     this._commonService.getData().subscribe(detailData => {
       if (detailData && detailData['collegeDetailAtaGlance']) {
         this.quickFactData = detailData['collegeDetailAtaGlance'];
       }
     });
  }

}
